export function VibrationUtils() {
    return {
        vibrate: (ms = 50) => {
            if (navigator.vibrate) {
                navigator.vibrate(ms);
            } else {
                console.log("이 기기는 진동을 지원하지 않습니다.");
            }
        }
    }
}